<template>
  <ul>
    <slot />
  </ul>
</template>

<script>
import Flickity from 'flickity'

export default {
  name: 'TheCarousel',

  props: {
    options: Object,
    manualInit: Boolean,
  },

  data() {
    return {
      selectedIndex: 0,
      currentSelectedElements: []
    }
  },

  mounted() {
    if (!this.manualInit) {
      this.init()
    }
  },

  beforeDestroy() {
    this.$flickity.destroy()
    this.$flickity = null
  },

  watch: {
    selectedIndex(i) {
      this.$emit('carousel-index', i)
    },
  },

  methods: {
    init() {
      this.$flickity = new Flickity(this.$el, this.options)
      this.$emit('init', this.$flickity)
      this.$flickity.on('change', i => {
        this.selectedIndex = i
        this.currentSelectedElements.forEach(cse => {
          cse.tabIndex = -1
        })
        this.currentSelectedElements = this.$flickity.selectedElements
        this.currentSelectedElements.forEach(cse => {
          cse.tabIndex = 0
        })
      })
      this.$flickity.cells.forEach(cell => {
        cell.element.tabIndex = -1
      })
      this.currentSelectedElements = this.$flickity.selectedElements
      this.currentSelectedElements.forEach(cse => {
        cse.tabIndex = 0
      })
    },

    next(isWrapped, isInstant) {
      this.$flickity.next(isWrapped, isInstant)
    },

    previous(isWrapped, isInstant) {
      this.$flickity.previous(isWrapped, isInstant)
    },

    selectCell(value, isWrapped, isInstant) {
      this.$flickity.selectCell(value, isWrapped, isInstant)
    },
  },
}
</script>

<style src="flickity/dist/flickity.css"></style>
